import React from 'react';
import type { ClusterOption } from './utils/clusterOptions';
import { NEXLA_CLOUD_VALUE } from './utils/clusterOptions';
import { RuntimeOptionContent } from './runtimeCardHelpers';
import styles from './RuntimeSelection.module.css';

export interface RuntimeSelectionDisplayProps {
  selectedClusterId: string | number | null | undefined;
  options: ClusterOption[];
}

function resolveSelectedOption(
  selectedClusterId: string | number | null | undefined,
  options: ClusterOption[],
): ClusterOption | undefined {
  if (selectedClusterId === null || selectedClusterId === undefined) {
    return options.find((o) => o.value === NEXLA_CLOUD_VALUE);
  }
  const idStr = String(selectedClusterId);
  return options.find((o) => o.value === idStr);
}

export default function RuntimeSelectionDisplay(props: RuntimeSelectionDisplayProps) {
  const { selectedClusterId, options } = props;
  const activeOption = resolveSelectedOption(selectedClusterId, options);

  if (!activeOption) return null;

  return (
    <div className={`${styles.card} ${styles.selected} ${styles.readOnly}`}>
      <RuntimeOptionContent option={activeOption} />
    </div>
  );
}
